import { Progress } from '@svenskaspelab/ui/react/progress';
import type { ReactNode } from 'react';

import BetslipProgressDisplay from './Betslip.ProgressDisplay.js';

type ProgressBarProps = {
  maxValue: number;
  currentValue: number;
};

/**
 * The progress bar for the betslip.
 *
 * @param root0 input object
 * @param root0.maxValue the maximum value that the betslip progress bar should be able to have
 * @param root0.currentValue the current value that the betslip progressbar has,
 * @returns The betslip progressbar.
 */
export default function BetslipProgressBar({ maxValue, currentValue }: ProgressBarProps): ReactNode {
  const value = (currentValue / maxValue) * 100;
  return (
    // TODO: Add aria-label
    <div
      /* aria-label="du har x antal rader kvar innan du kan betala" */ className="grid grid-cols-[auto_min-content] items-center gap-[12px] [grid-area:progressBar]"
    >
      <Progress value={value} />
      <BetslipProgressDisplay eventsStarted={currentValue} maxEvents={maxValue} />
    </div>
  );
}
